import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ShareLinkBtnsComponent} from './share-link-btns/share-link-btns.component';
import {CopyLinkBtnComponent} from './copy-link-btn/copy-link-btn.component';
import {LinkOverlayComponent} from './link-overlay/link-overlay.component';
import {TranslationsModule} from '@common/core/translations/translations.module';
import {CustomMenuModule} from '@common/core/ui/custom-menu/custom-menu.module';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {MatTooltipModule} from '@angular/material/tooltip';
import { MatDialogModule } from '@angular/material/dialog';
import { CustomizeQrCodeComponent } from './customize-qr-code/customize-qr-code.component';
import { QRCodeModule } from 'angularx-qrcode';
import { ColorPickerInputModule } from '@common/core/ui/color-picker/color-picker-input/color-picker-input.module';
import { MatSliderModule } from '@angular/material/slider';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

@NgModule({
    declarations: [
        ShareLinkBtnsComponent,
        CopyLinkBtnComponent,
        LinkOverlayComponent,
        CustomizeQrCodeComponent,
    ],
    imports: [
        CommonModule,
        TranslationsModule,
        CustomMenuModule,
        FormsModule,
        RouterModule,

        // material
        MatSliderModule,
        MatButtonModule,
        MatIconModule,
        MatTooltipModule,
        MatDialogModule,
        QRCodeModule,
        ColorPickerInputModule,
    ],
    exports: [
        ShareLinkBtnsComponent,
        CopyLinkBtnComponent,
        LinkOverlayComponent,
        CustomizeQrCodeComponent,
    ]
})
export class SharedModule {
}
